<ion-content class="ion-padding">
  <div class="otp-wrapper animate-fade-in">
    <div class="otp-container standard-card">
      <ion-button fill="clear" class="close-button" (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>

      <div class="otp-header">
        <ion-icon name="shield-checkmark-outline" class="shield-icon"></ion-icon>
        <h1>Verify OTP</h1>
        <p class="subtitle">Enter the 6-digit code sent to your device</p>
      </div>

      <div class="otp-input-container">
        <ng-otp-input #otpInput (onInputChange)="onOtpChange($event)" [config]="{
            length: 6,
            inputStyles: {
              width: '45px',
              height: '50px',
              fontSize: '24px',
              fontWeight: '800'
            }
          }">
        </ng-otp-input>
      </div>

      <p class="countdown" [class.danger]="countdown <= 10">
        <ion-icon name="time-outline"></ion-icon>
        {{ countdown }} seconds remaining
      </p>

      <ion-button expand="block" class="large" color="primary" [disabled]="!otp || otp.length !== 6" (click)="verifyOtp()">
        <ng-container *ngIf="!approve2">
          Verify
        </ng-container>
        <ion-spinner *ngIf="approve2" name="crescent"></ion-spinner>
      </ion-button>

      <ion-button expand="block" fill="clear" class="resend-button" [disabled]="countdown > 0" (click)="resend()">
        <ion-icon name="refresh-outline" slot="start"></ion-icon>
        Resend Code
      </ion-button>
    </div>
  </div>
</ion-content>